import { reducer as formReducer } from "redux-form";
import { combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";

import analytics from "./app-analytics";
import reporteadorError from "./app-error";
import { flags } from "./properties";
import { appRdc } from "./app-reducer";
import { personaRdc } from "./ej/persona-rdc";
import { registroRdc } from "./registro/reducer";
import { registroFamiliarRdc } from "./registro-familiar/reducer";
import { polizasRdc } from "./home/reducer";
import { notificacionesRdc } from "./notificaciones/reducer";
import { tramitesRdc } from "./mis-tramites/reducer";
import { directorioRdc } from "./directorio/reducer";
import { contratoRdc } from "./contrato/reducer";
import { movilRdc } from "./app-movil";
import { olvideRdc } from "./olvide/reducer";
import { olvideContraseniaRdc } from "./gnp-olvide-contrasenia/reducer";
import { loginRdc } from "./gnp-login/reducer";
import { modificarRdc } from "./modificar/reducer";
import { miPerfilRdc } from "./miPerfil/reducer";
import { asistidoRdc } from "./registro-asistido/reducer";
import { accesoFamiliarRdc } from "./acceso-familiar/reducer";
import { catalogosRdc } from "./catalogos/reducer";
import { modalAlertRdc } from "./modal-alert/reducer";
import { recuperarRdc } from "./recuperar-contrasenia/reducer";
import { descargasRdc } from "./descargas/reducer";
import { siniestrosRdc } from "./seguimiento-siniestros/reducer";
import { polizasMovilRdc } from "./movil/polizas/reducer";
import { videosRdc } from "./gnp-servicios/reducer";
import { registroDbkRdc } from "./autorizadorDBK/km0/reducer";
import { beneficiosRdc } from "./Beneficios/reducer";
import { multicanalRdc } from "./gnp-multicanal/reducer";
import { parentesco } from "./parentesco/reducer";
import { pagoDeducibleAutoRdc } from './pago-deducible-auto/pagoDeducibleAuto-reducer';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

appState.$inject = ["$ngReduxProvider"];

export default function appState($ngRedux) {
  // Rutina para crear reductor base con la finalidad de poderlo limpiar al cerrar sesion
  const appReducers = combineReducers({
    global: appRdc,
    catalogos: catalogosRdc,
    persona: personaRdc,
    registro: registroRdc,
    registroAF: registroFamiliarRdc,
    form: formReducer,
    polizas: polizasRdc,
    notificaciones: notificacionesRdc,
    directorio: directorioRdc,
    tramites: tramitesRdc,
    contrato: contratoRdc,
    movil: movilRdc,
    olvide: olvideRdc,
    olvideContrasenia: olvideContraseniaRdc,
    login: loginRdc,
    modificar: modificarRdc,
    miPerfil: miPerfilRdc,
    asistido: asistidoRdc,
    af: accesoFamiliarRdc,
    modal: modalAlertRdc,
    recuperar: recuperarRdc,
    descargas: descargasRdc,
    siniestros: siniestrosRdc,
    polizasMovil: polizasMovilRdc,
    videos: videosRdc,
    registroDbk: registroDbkRdc,
    beneficiosGnp: beneficiosRdc,
    multicanalGnp: multicanalRdc,
    parentesco: parentesco,
    "pagoDeducibleAutos": pagoDeducibleAutoRdc,
    __SUPER_SECRET_FEATURE_FLAGS__: (state = {}) => state,
  });

  const rootReducer = (state, action) => {
    if (action.type === "USER_LOGOUT") {
      state = undefined;
    }

    return appReducers(state, action);
  };
  // Fin de rutina para limpiar estado al finalizar sesion

  $ngRedux.createStoreWith(
    rootReducer,
    [],
    [composeEnhancers(applyMiddleware(analytics, reporteadorError, thunk))]
  );
}



// WEBPACK FOOTER //
// ./src/app-state.js